export default function Loader() {
    console.log("dddddddddd");
    return (
        <div className="preloader_bg" id="preloader_bg" style={{ display: "none" }}>
            <div className="preloader_img">
                <img src="/assets/images/loader.png" alt="" />
            </div>
        </div>
    )
}